import React, { useEffect, useState } from "react";
import { BsSunFill, BsMoonStarsFill } from "react-icons/bs";
import { themes, DEFAULT_THEME, THEME_STORAGE_KEY } from "../../data/themes";

const icons = {
  midnight: <BsMoonStarsFill />,
  daylight: <BsSunFill />,
};

const getStoredTheme = () => {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return themes.some((theme) => theme.id === stored) ? stored : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

// layout="rail" matches the vertical icon column (desktop). layout="pill"
// is a horizontal control for placements outside that column (e.g. the
// bottom of the mobile page); pass compact to shrink it further.
const ThemeSwitcher = ({ layout = "rail", compact = false }) => {
  const [theme, setTheme] = useState(getStoredTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // Private browsing: theme still applies, just isn't remembered.
    }
  }, [theme]);

  const isRail = layout === "rail";

  return (
    <div
      role="group"
      aria-label="Color theme"
      className={`bg-bodyColor rounded-3xl flex items-center justify-center ${
        isRail
          ? "w-full flex-col gap-4 py-5"
          : compact
          ? "gap-1 px-1.5 py-1.5"
          : "gap-1 px-2 py-2 shadow-testShwdow"
      }`}
    >
      {themes.map(({ id, name }) => (
        <button
          key={id}
          type="button"
          onClick={() => setTheme(id)}
          aria-label={`${name} mode`}
          aria-pressed={theme === id}
          title={`${name} mode`}
          className={`flex items-center justify-center rounded-full duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-designColor focus-visible:ring-offset-2 focus-visible:ring-offset-bodyColor ${
            isRail ? "w-full h-6 text-xl" : compact ? "w-7 h-7 text-sm" : "w-9 h-9 text-lg"
          } ${
            theme === id
              ? "text-designColor"
              : "text-textColor hover:text-designColor"
          }`}
        >
          {icons[id]}
        </button>
      ))}
    </div>
  );
};

export default ThemeSwitcher;
